
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 50 50","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"#010002"}},[_c('path',{attrs:{"d":"M2 25a4 4 0 014-4h38a4 4 0 110 8H6a4 4 0 01-4-4z"}}),_c('path',{attrs:{"d":"M21 44V6a4 4 0 118 0v38a4 4 0 11-8 0z"}})])])
          )
        }
      }
    